import { parseISO } from 'date-fns';
import type { GlobalSearchResultItemDataObject, SearchResultsDataObject } from './service';

export type GlobalSearchResultItem = {
  assetableId?: string;
  assetableType?: string;
  coverPhoto?: string;
  createdAt?: Date;
  description?: string;
  file?: {
    contentType: string;
    url: string;
  };
  firstName?: string;
  id: string;
  joined?: boolean;
  lastName?: string;
  name?: string;
  organization?: { name: string };
  place?: string;
  postInCommunities?: Array<{ name: string }>;
  profilePhoto?: string;
  startTime?: Date;
  textContent?: string;
  type?: string;
};

export const createGlobalSearchResultItem = (data: GlobalSearchResultItemDataObject): GlobalSearchResultItem => ({
  assetableId: data.assetable_id,
  assetableType: data.assetable_type,
  coverPhoto: data.cover_photo,
  createdAt: data.created_at ? parseISO(data.created_at) : undefined,
  description: data.description,
  file: data.file ? { contentType: data.file.content_type, url: data.file.url } : undefined,
  firstName: data.first_name,
  id: data.id,
  joined: data.joined,
  lastName: data.last_name,
  name: data.name,
  organization: data.organization,
  place: data.place,
  postInCommunities: data.post_in_communities,
  profilePhoto: data.profile_photo,
  startTime: data.start_time ? parseISO(data.start_time) : undefined,
  textContent: data.text_content,
  type: data.type,
});

export const createGlobalSearchResultItems = (data: GlobalSearchResultItemDataObject[]): GlobalSearchResultItem[] =>
  data.map((item) => createGlobalSearchResultItem(item));

export type SearchItemTypeKey =
  | 'activities'
  | 'communities'
  | 'events'
  | 'files'
  | 'givings'
  | 'organizations'
  | 'polls'
  | 'posts'
  | 'programs'
  | 'users';

export const searchItemTypeKeys: SearchItemTypeKey[] = [
  'activities',
  'communities',
  'events',
  'files',
  'givings',
  'organizations',
  'polls',
  'posts',
  'programs',
  'users',
];

export type SearchResultsData = Partial<Record<`${SearchItemTypeKey}Count`, number>> &
  Partial<Record<SearchItemTypeKey, GlobalSearchResultItem[]>>;

export const createSearchResultsData = (data: SearchResultsDataObject): SearchResultsData => {
  const result: SearchResultsData = {};

  for (const key of searchItemTypeKeys) {
    const items = data[key];
    if (items) {
      result[key] = createGlobalSearchResultItems(items);
    }

    const count = data[`${key}_count`];
    if (count !== undefined) {
      result[`${key}Count`] = count;
    }
  }

  return result;
};
